import React, { useState } from "react";
import { trackEvent } from "../analytics/ga";
import { getApiUrl } from "../api/apiClient";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = ({ ui }) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [status, setStatus] = useState("idle");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name: field, value } = e.target;
    setState((prevState) => ({ ...prevState, [field]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("idle");
    setSubmitting(true);

    try {
      const apiUrl = getApiUrl();
      const response = await fetch(`${apiUrl}/contact/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim(),
          message: message.trim(),
        }),
      });

      if (!response.ok) {
        throw new Error("Request failed");
      }

      clearState();
      setStatus("success");
      trackEvent({ category: "Contact", action: "Submit", label: "success" });
    } catch (err) {
      setStatus("error");
      trackEvent({ category: "Contact", action: "Submit", label: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="row contact-row">
            <div className="col-md-8 col-md-offset-2">
              <div className="section-title text-center">
                <h2>{ui?.title}</h2>
                {ui?.subtitle ? <p>{ui.subtitle}</p> : null}
              </div>

              <form name="sentMessage" onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder={ui?.namePlaceholder}
                        required
                        value={name}
                        onChange={handleChange}
                        disabled={submitting}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder={ui?.emailPlaceholder}
                        required
                        value={email}
                        onChange={handleChange}
                        disabled={submitting}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder={ui?.messagePlaceholder}
                    required
                    value={message}
                    onChange={handleChange}
                    disabled={submitting}
                  />
                </div>
                {status === "success" ? (
                  <p className="contact-form-status contact-form-status--success">
                    {ui?.success}
                  </p>
                ) : null}
                {status === "error" ? (
                  <p className="contact-form-status contact-form-status--error">
                    {ui?.error}
                  </p>
                ) : null}
                <button
                  type="submit"
                  className="btn btn-custom btn-lg"
                  disabled={submitting}
                >
                  {submitting ? ui?.sending : ui?.send}
                </button>
              </form>

              <p className="contact-privacy-link-wrap text-center">
                <a
                  className="contact-privacy-link"
                  href="/privacy-policy.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  {ui?.privacyPolicy}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
